import type { CreateQuestionRequestDto, CreateSurveyRequestDto, QuestionDto } from "@/api/types";

interface Option {
  oId?: string;
  option: string;
}

export interface Question {
  qId?: string;
  type: QuestionDto["type"];
  question: string;
  options: Option[];
  useForAnalysis?: boolean;
}

export const surveyCategories = ["other", "feelAtHome"] as const satisfies CreateSurveyRequestDto["category"][];

export const questionTypes = [
  "open",
  "yesNo",
  "multipleChoice",
  "rating",
] as const satisfies CreateQuestionRequestDto["type"][];

export const feelingAtHomeTemplate = {
  title: "template.survey.feel-at-home.title",
  description: "template.survey.feel-at-home.description",
  thankYouMessage: "template.survey.feel-at-home.thank-you-message",
  questions: [
    {
      title: "template.survey.feel-at-home.questions.1.text",
      type: "rating",
      useForAnalysis: false,
    },
    {
      title: "template.survey.feel-at-home.questions.2.text",
      type: "rating",
      useForAnalysis: false,
    },
    {
      title: "template.survey.feel-at-home.questions.3.text",
      type: "multipleChoice",
      options: [
        { option: "template.survey.feel-at-home.questions.3.options.1.text" },
        { option: "template.survey.feel-at-home.questions.3.options.2.text" },
        { option: "template.survey.feel-at-home.questions.3.options.3.text" },
        { option: "template.survey.feel-at-home.questions.3.options.4.text" },
        { option: "template.survey.feel-at-home.questions.3.options.5.text" },
      ],
    },
    {
      title: "template.survey.feel-at-home.questions.4.text",
      type: "open",
    },
    {
      title: "template.survey.feel-at-home.questions.5.text",
      type: "open",
    },
    {
      title: "template.survey.feel-at-home.questions.6.text",
      type: "open",
    },
  ],
} as const;
